import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { errorLayoutRoute } from "../__root";
import { ROUTER_HELPERS } from "@/shared/constants/router";

const UnauthorisedErrorRoute = lazyRouteComponent(
  () => import("@/components/errors/unauthorized-error")
);

export const unauthorisedErrorRoute = createRoute({
  getParentRoute: () => errorLayoutRoute,
  path: ROUTER_HELPERS.error(401),
  component: UnauthorisedErrorRoute,
});
